import { render } from "./PhoneInputComponent.vue?vue&type=template&id=003376a0&scoped=true"
import script from "./PhoneInputComponent.vue?vue&type=script&lang=js"
export * from "./PhoneInputComponent.vue?vue&type=script&lang=js"

import "./PhoneInputComponent.vue?vue&type=style&index=0&id=003376a0&scoped=true&lang=css"

import exportComponent from "../../../../../../../traveldesk-booking/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-003376a0"]])

export default __exports__